import {
  PlusCircle,
  Sparkles,
  Upload,
  RefreshCw,
  ArrowRight
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type OptionCardProps = {
  icon: 'new' | 'ai' | 'upload' | 'linkedin';
  title: string;
  description: string;
  action: string;
  highlighted?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

const iconMap = {
  new: PlusCircle,
  ai: Sparkles,
  upload: Upload,
  linkedin: RefreshCw
};

const OptionCard = ({
  icon,
  title,
  description,
  action,
  highlighted,
  disabled,
  onClick
}: OptionCardProps) => {
  const Icon = iconMap[icon];
  const navigate = useNavigate();

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`relative rounded-lg border bg-white p-5 text-left shadow-sm transition-all ${
        disabled ? 'cursor-not-allowed opacity-50' : 'hover:-translate-y-1'
      } ${
        highlighted
          ? 'border-brand/30 bg-gamma'
          : 'border-transparent hover:border-brand/20'
      }`}
    >
      {highlighted && (
        <div className='absolute right-3 top-3'>
          <span className='rounded-full bg-gradient-to-r from-brand via-primary to-beta px-2 py-1 text-[9px] font-semibold uppercase text-white shadow-md shadow-brand/30'>
            Recommended
          </span>
        </div>
      )}
      {disabled && (
        <div className='absolute right-3 top-3'>
          <span className='rounded-full bg-gray-400 px-2 py-1 text-[9px] font-semibold uppercase text-white'>
            Coming Soon
          </span>
        </div>
      )}

      <div className='mb-4 flex h-10 w-10 items-center justify-center rounded-md bg-gamma'>
        <Icon className='h-5 w-5 text-brand' />
      </div>

      <h3 className='mb-1 text-base font-bold'>{title}</h3>

      <p className='mb-4 text-xs text-gray-500'>{description}</p>

      <div className='flex items-center text-xs font-semibold text-brand'>
        <span>{action}</span>

        <ArrowRight className='ml-1 h-3 w-3' />
      </div>
    </button>
  );
};

export default OptionCard;
